import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { PermissionGate } from "@/modules/auth/presentation/ui/PermissionGate";
import { Button } from "@devhop/ui";
import { useNavigate } from "@tanstack/react-router";
import {
  BanknoteIcon,
  ClipboardListIcon,
  PlusIcon,
} from "lucide-react";

export function PerformanceOperationsOverviewSection() {
  const nav = useNavigate();
  const canCreateRequest = useActionPermission(["performance-requests:create"]);
  const canCreateEvent = useActionPermission(["performance-events:create"]);

  return (
    <section>
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <h1 className="font-semibold text-2xl tracking-tight">
          ແຜງຄວບຄຸມງານສະແດງ
        </h1>
        <div className="flex flex-wrap items-end gap-2">
          {canCreateRequest ? (
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="h-9 bg-background"
              onClick={() => void nav({ to: "/app/performance/requests/create" })}
            >
              <PlusIcon className="mr-2 size-4" />
              ສ້າງຄຳຂໍໃໝ່
            </Button>
          ) : null}
          {canCreateEvent ? (
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="h-9 bg-background"
              onClick={() => void nav({ to: "/app/performance/events/create" })}
            >
              <PlusIcon className="mr-2 size-4" />
              ສ້າງງານໃໝ່
            </Button>
          ) : null}
          <PermissionGate all={["performance-requests:read"]}>
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="h-9 bg-background"
              onClick={() => void nav({ to: "/app/performance/requests" })}
            >
              <ClipboardListIcon className="mr-2 size-4" />
              ເບິ່ງຄິວ
            </Button>
          </PermissionGate>
          <PermissionGate all={["performance-reports:read"]}>
            <Button
              type="button"
              size="sm"
              variant="outline"
              className="h-9 bg-background"
              onClick={() => void nav({ to: "/app/performance/reports" })}
            >
              <BanknoteIcon className="mr-2 size-4" />
              ລາຍງານ
            </Button>
          </PermissionGate>
        </div>
      </div>
    </section>
  );
}
